import { render, staticRenderFns } from "./asset-files.vue?vue&type=template&id=bb4efa1a&scoped=true&"
import script from "./asset-files.vue?vue&type=script&lang=js&"
export * from "./asset-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4efa1a",
  null
  
)

export default component.exports